<!--
@Description: 多个页面都有这个雪碧图商店的调用，封装出组件使用 使用方法 <div shopType="taobao">
@Author: 吳廣帥
@Date:2021/5/20 - 12:07
@Name:index
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.icon-box {
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  background-image:url(https://s6.bihukankan.com/img/1645091562shop-icon.png);
  background-size: 160px 16px;
}
.default{
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;

}
</style>
<template>
  <!--  组件最外层盒子-->
  <div  class="icon-box" :title="title" :style="{ 'background-position': `${position} 0` }"/>
</template>
<script>

export default {
  props: {
    shopType: [String,Number],//店铺类型
    isNumberSign:Boolean, // 数字标识
  },
  computed:{
    title(){
      if(!this.$props.isNumberSign) return this.label[this.$props.shopType]
      return this.label[this.sourceType[this.shopType]]
    },
    position() {
      if(!this.$props.isNumberSign) return this.positionIcon[this.$props.shopType]
      return this.positionIcon[this.sourceType[this.shopType]]
    }
  },
  data() {
    return {
      /** 静态数据（存放静态地址、组件内静态json数据等） **/
        label:{
          taobao:'淘宝',
          mokuai:'魔筷',
          youzan:'有赞',
          pdd:'品多多',
          course:'快手课堂',
          gifshow:'快手小店',
          shangou:'闪购',
          jd:'京东',
          suning:'苏宁',
          localLife:'本地生活'
        },
        positionIcon:{
          gifshow:'0px',
          youzan:'-16px',
          mokuai:'-32px',
          taobao:'-48px',
          shangou:'-64px',
          course:'-80px',
          localLife:'-96px',
          jd:'-112px',
          pdd:'-128px',
          suning:'-144px',
        },

        sourceType:{
          1: 'course',
          2: 'taobao',
          4: 'mokuai',
          5: 'youzan',
          97: 'localLife',
          98: 'shangou',
          99: 'gifshow'
        }
    }
  },
}
</script>








